import isNil from 'lodash/isNil';
import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ReportingHistoryItemContainer = styled.div.attrs({
  className: 'reportingHistoryItem'
})`
  width: 100%;

  padding: 20px;

  display: flex;
  flex-direction: column;

  border: 1px solid black;
  border-radius: 5px;
`;

export const ReportingHistoryItemDateLabel = styled.div.attrs({
  className: 'reportingHistoryItemDateLabel'
})`
  font-size: 18px;
`;

export const ReportingHistoryItemColumnLabel = styled.div.attrs({
  className: 'reportingHistoryItemColumnLabel'
})`
  font-size: 18px;
`;

export const ReportingHistoryDataRow = styled.div.attrs({
  className: 'reportingHistoryDataRow'
})`
  width: 100%;

  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export type TFlexerProps = {
  size: 'sm' | 'md' | 'lg';
  minWidth?: string;
  textAlign?: string;
  justifyContent?: string;
};

export const Flexer = styled.div`
  flex: ${(props: TFlexerProps) => {
    switch (props.size) {
      case 'sm':
        return 1;
      case 'md':
        return 1.5;
      case 'lg':
        return 2;
    }
  }};

  min-width: ${(props: TFlexerProps) => {
    if (isNil(props.minWidth)) return '75px';
    return props.minWidth;
  }};
  
  display: flex;
  align-items: center;
  justify-content: ${(props: TFlexerProps) => {
    if (isNil(props.justifyContent)) return 'inherit';
    return props.justifyContent;
  }};
  
  text-align: ${(props: TFlexerProps) => {
    if (isNil(props.textAlign)) return 'center';
    return props.textAlign;
}};
`;

export const ExpanderContainer = styled.div`
  width: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;